import Service from "../../services";

const urgencyHospitalTypeModule = {
    namespaced: true,
    state: { list: [] },
    mutations: {
        SET_ALL: (state, data) => {
            state.list = data;
        }
    },
    actions: {
        setAll({ commit }) {
            Service.urgencyHospitalType
                .getAllUrgencyHospitalTypes()
                .then(res => {
                    commit("SET_ALL", res);
                });
        }
    },
    getters: {
        getAll(state) {
            return state.list;
        }
    }
};
export default urgencyHospitalTypeModule;
